import { eUSAState } from '../../../enums/states';

export interface ICountyResponse {
  id: string;
  name: string;
  state?: eUSAState;
  fips?: string;
}

export type ICountyData = ICountyResponse;

export const convertFromCountyResponseArrayToCountyDataArray = (data: ICountyResponse[]): ICountyData[] => data;
